module.exports = __webpack_public_path__ + "static/media/icon_service.372e22a5.svg";